<template>
  <CountryPage country="bahrain" />
</template>